import { LeadingWealthManager } from './LeadingWealthManager'
import { reactToCwp } from '../../../../common/react-utils'

export default reactToCwp(LeadingWealthManager)
